<div class="container marginMobile">
   <div class="col-sm-12 breadcrumb py-3 m-0">
     <a href="#">Produits</a>&nbsp;>&nbsp;Ceratube
   </div>
 </div>
 <!-- Fin breadcrumb -->
      <!-- Les A-propos -->
        <div class="container-fluid gradientAproposCeratube">
          <div class="container">
            <div class="row rowApropos">
              <div class="col-sm-6">
                <img src="assets/front/images/aproposceratube.png" alt="" class="img-fluid aproposImg"/>
              </div>
              <div class="col-sm-1">
              </div>
              <div class="col-sm-5">
                <div class="sousTitreRubriqueLeft">
                  À propos de nous
                </div>
                <div class="separApropos"></div>
                <div class="descriptionApropos">
                  <p><strong>Ceratube : la référence sur le marché du sanitaire au Maroc</strong></p>
                  <p>Ceratube est une société marocaine spécialisée dans la l’limportation et la distrubution de matériels sanitaires, plomberie générale, robinetterie, chauffage et climatisation.</p>
                  <p>Présente sur le marché depuis plus de 25 ans, Ceratube allie à la fois la passion, le savoir-faire et la performance dans son métier  pour vous apporter des produits pensés pour votre bien-être et votre confort quotidien.</p>
                  <p>Avec une large sélection de produits sélectionnés avec soin, parmi les plus grandes marques européennes expertes dans leur domaine, Ceratube vous offre la meilleure combinaison en termes de qualité, durabilité et prix pour tous vos projets de rénovation et d’aménagement.</p>
                </div>
                <!-- <button class="btn voirPlusBtnRouge">Voir toutes les collections <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Les A-propos FIN -->
        <!--Mission début-->
        <div class="container-fluid gradientMissionCeratube">
            <div class="container">
              <div class="row rowMission">
                <div class="col-sm-7">
                    <div class="sousTitreRubriqueRight mt-3">
                      Notre mission
                    </div>
                    <div class="separMission"></div>
                    <br/>
                    <div class="row icons">

                            <div class="col-md-4">
                                <div class="icon1 text-end">
                                    <div class="text-end"><img src="assets/front/images/check.png"/></div>
                                    <div class="iconTitle"><h3>Disponibilité des produits</h3></div>
                                    <div class="iconDescription"><p>Avec plus de 17000 m2 de stockage,  Disponibilité des produits et rapidité d’expédition partout au MAROC nos magasins sont répartis sur plusieurs villes, pour vous aider à visualiser concrètement vos futurs projets, et à bénéficier également des conseils personnalisés de nos équipes et collaborateurs expérimentés.</p></div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="icon1 text-end">
                                    <div class="text-end"><img src="assets/front/images/medal.png"/></div>
                                    <div class="iconTitle"><h3>Qualité des matériaux</h3></div>
                                    <div class="iconDescription"><p>Nous choisissons auprès de nos fournisseurs les produits qui répondent en premier aux conditions de qualité et durabilité, tout en s’alliant aux conformités et normes internationales de qualité.
Avec plus de 80 références de marques européennes reconnues, nous nous engageons à vous garantir des produits durables et de qualité.</p></div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="icon1 text-end">
                                    <div class="text-end"><img src="assets/front/images/technical-support.png"/></div>
                                    <div class="iconTitle"><h3>Accompagnement personnalisé</h3></div>
                                    <div class="iconDescription"><p>La compétence et l’expérience sont nos maîtres mots. Nous offrons un service qualifié dédié uniquement pour étudier et estimer le budget nécessaire à vos approvisionnements.
Nous vous proposons un accompagnement sur-mesure, basé sur l'expertise de nos équipes qui vous apporteront les conseils nécessaires pour réussir tous vos projets d’aménagement.</p>
</div>
                                  </div>
                            </div>

                    </div>
                  </div>
                <div class="col-sm-4">
                  <img src="assets/front/images/mission.png" alt="" class="img-fluid aproposImg"/>
                </div>

              </div>
            </div>
          </div>
        <!--Mission fin-->
         <!-- Début Robimed -->
         <div class="container-fluid gradientRobimedapropos">
            <div class="container">
              <div class="row rowRobimed">
                <div class="col-sm-6">
                  <img src="assets/front/images/robimed.png" alt="" class="img-fluid aproposImg"/>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-5">
                  <div class="col-sm-12">
                    <div class="col-sm-12 sousTitreRubrique">
                        Robimed
                        <div class="separRobimed"></div>
                    </div>
                </div>
                  <p class="descriptionRobimed">
                    En tant qu’ambassadeur des équipements sanitaires au Maroc, et grâce à notre expérience de plus de 25 ans, nous nous sommes engagés à introduire sur le marché des produits faciles à exploiter, et viables en qualité.
                    Nous sommes particulièrement attentifs à une utilisation quotidienne irréprochable, qui tient en compte l’économie d’eau et la protection de l'environnement. De ce fait, nous tenons à ce que chacun de nos produits représente l’harmonie parfaite de technologie, de qualité et de design.
                  </p>
                  <a href="/robimeds"><button class="btn voirPlusBtnRouge">Voir toutes les collections <i class="fa fa-chevron-right" aria-hidden="true"></i></button></a>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin Robimed -->
          <!-- Début Showroom-->
          <div class="container-fluid">
            <div class="container">
              <div class="row pb-5 g-5">
                <div class="col-sm-12">
                    <div class="col-sm-12 mt-5 titreRubrique text-center">
                        showroom
                       <div class="separTitres"></div>
                    </div>
                    <div class="col-sm-12 sousTitreRubrique text-center">
                        Découvrez notre Showroom
                    </div>
                </div>
                <div class="col-sm-12">
                    <div id="carouselExampleControls" class="carousel slide showroom" data-bs-ride="carousel">
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src="assets/front/images/showroom1.png" class="img-fluid d-block w-80" alt="...">
                            <h3 class="carouselTitle">Lorem ipsum dolor</h3>
                            <p class="carouseldescription">Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                          </div>
                          <div class="carousel-item">
                            <img src="assets/front/images/robimed.png" class="img-fluid d-block w-80" alt="...">
                            <h3 class="carouselTitle">Lorem ipsum dolor</h3>
                            <p class="carouseldescription">Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                          </div>
                          <div class="carousel-item">
                            <img src="assets/front/images/showroom1.png" class="img-fluid d-block w-80" alt="...">
                            <h3 class="carouselTitle">Lorem ipsum dolor</h3>
                            <p class="carouseldescription">Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin Showroom-->
          <!-- Début Marques-->
          <div class="container-fluid contentGris">
            <div class="container debutDePage">
               <div class="row nosMarques">
                  <div class="col-sm-12 titreRubrique text-center">
                     NOS MARQUES
                     <div class="separTitres"></div>
                  </div>
                  <div class="col-sm-12 sousTitreRubrique text-center">
                     Spécialiste réputé des équipements sanitaires!
                  </div>
               </div>
               <div class="container">
                   <div class="row g-4 my-5 mx-auto owl-carousel markCarousel owl-theme owl-loaded owl-drag">
                   <div class="owl-stage-outer">
                     <div class="owl-stage" style="transform: translate3d(-2289px, 0px, 0px); transition: all 0.25s ease 0s; width: 4580px;">
                       <div class="owl-item" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo1.png" alt="logo1"></a>
                       </div></div>
                       <div class="owl-item" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo2.png" alt="logo2"></a>
                       </div></div>
                       <div class="owl-item" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo3.png" alt="logo3"></a>
                       </div></div>
                       <div class="owl-item" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo4.png" alt="logo4"></a>
                       </div></div>
                       <div class="owl-item active" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo5.png" alt="logo5"></a>
                       </div></div>
                       <div class="owl-item active" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo6.png" alt="logo6"></a>
                       </div></div>
                       <div class="owl-item active" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo7.png" alt="logo7"></a>
                       </div></div>
                       <div class="owl-item active" style="width: 254.4px;">
                         <div class="col product-item mx-auto">
                         <a href="#"><img class="logomark" src="assets/front/images/logo8.png" alt="logo8"></a>
                       </div></div>
                     </div>
                   </div>
               </div>
            </div>
         </div>
          <!-- Fin Marques-->
